import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-full w-full" }
const _hoisted_2 = { class: "__setup-target-smart __section shadow-sm bg-white overflow-hidden" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "__section__header font-semibold text-neutral-600 p-6 border-b" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-600" }, "Luca AI"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "text-neutral-500 font-normal leading-5 text-sm mt-2",
    style: {"max-width":"700px"}
  }, " Ở chế độ bật, cơ sở can thiệp có thể sử dụng Luca AI ")
], -1)
const _hoisted_4 = { class: "__section__content" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "input-group flex-nowrap flex items-center justify-between p-6 bg-neutral-50" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label w-56 uppercase text-neutral-400 text-xs font-semibold" }, " Sử dụng luca AI ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SwitchButton = _resolveComponent("SwitchButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_SwitchButton, {
              value: _ctx.enable_ai_button,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.enable_ai_button) = $event))
            }, null, 8, ["value"])
          ])
        ])
      ])
    ])
  ]))
}